import { useActivityPageContext } from "PFApp/activities/show/activity_page_context";
import { MatchesChart } from "PFApp/activities/show/matches_v2/components/matches_chart";
import { RoleInformation } from "PFApp/activities/show/matches_v2/components/role_information";
import React from "react";

import css from "./side_panel.module.scss";

export const SidePanel = () => {
  const { task } = useActivityPageContext();

  if (!task) {
    return null;
  }

  return (
    <div className={css.container}>
      <RoleInformation role={task} />
      <MatchesChart />
    </div>
  );
};
